/* Automatically generated by './build/bin/build-entry.js' */

import SummarComplaints from './SummarComplaints.vue'

SummarComplaints.install = function(Vue, opts = {}) {
  Vue.component(SummarComplaints.name, SummarComplaints)
}

export default SummarComplaints
